// Inspired by: https://webaim.org/techniques/css/invisiblecontent/

import React from 'react'

import cn from 'classnames'

import styles from './visually-hidden.module.scss'

interface VisuallyHiddenProps {
  className?: string
  children?: React.ReactNode
}

export const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({ className, children }) => {
  return <div className={cn(styles.visuallyHidden, className)}>{children}</div>
}
